import angular from 'angular';
import constants from 'app/constants';
import {
  praDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './bulk-reset-processes-dialog.controller';
import template from './bulk-reset-processes-dialog.html';


class dialogService {
  getOptions($event, { processes, assessmentId }) {
    return {
      controller,
      controllerAs: 'bulkResetProcessesDialogVM',
      locals: {
        processes,
        assessmentId
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pra.bulkResetProcessesDialog', [
  alerts,
  praDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('bulkResetProcessesDialog', dialogService)
  .name;
